import { Helpers } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';
import { DatePeriodFormControlName } from '../enums';

export default class DatePeriodQueryMapper {
  static mapFromQueries(queries) {
    return Helpers.ObjectHelper.removeEmptyProperties({
      [DatePeriodFormControlName.DatePeriod]: queries[QueryParams.TransactionDate],
    });
  }

  static mapToQueries(formData) {
    return Helpers.ObjectHelper.removeEmptyProperties({
      [QueryParams.TransactionDate]: formData[DatePeriodFormControlName.DatePeriod],
    });
  }
}
